<template>
  <div>
    <!--begin::Body-->
    <div class="kt-login__body">
      <!--begin::Signin-->
      <div class="kt-login__form">
        <!--begin::Form-->
        <b-form
          class="kt-form form elevation-1"
          @submit.stop.prevent="onSubmit"
        >
          <div class="div heading">
            <h2 class="form-heading">PAYNOWPRO</h2>
            <p>Forgot Password</p>
          </div>
          <b-form-group
            id="email-input-group"
            class="form-group"
            label
            label-for="email"
            ><label class="d1-block">Email Address</label>
            <b-form-input
              class="input"
              id="email-input"
              name="email"
              v-model="$v.form.email.$model"
              :state="validateState('email')"
              aria-describedby="email-feedback"
              placeholder=""
            ></b-form-input>

            <b-form-invalid-feedback id="email-feedback"
              >A valid email address is required.</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group
            id="code-input-group"
            class="form-group"
            label
            label-for="code"
            ><label class="d1-block">Code</label>
            <b-form-input
              class="input"
              id="code"
              name="code"
              v-model="$v.form.code.$model"
              :state="validateState('code')"
              aria-describedby="code-feedback"
              placeholder=""
            ></b-form-input>

            <b-form-invalid-feedback id="code-feedback"
              >Confirmation code is required.</b-form-invalid-feedback
            >
          </b-form-group>

          <b-form-group
            id="password-input-group"
            class="form-group"
            label
            label-for="password"
            ><label class="d1-block">New Password</label>
            <b-form-input
              class="input"
              type="password"
              id="password"
              name="password"
              v-model="$v.form.password.$model"
              :state="validateState('password')"
              aria-describedby="password-feedback"
              placeholder=""
            ></b-form-input>

            <b-form-invalid-feedback id="password-feedback">{{
              invalidPasswordMessage
            }}</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            id="confirm-input-group"
            class="form-group"
            label
            label-for="confirm"
            ><label class="d1-block">Confirm New Password</label>
            <b-form-input
              class="input"
              type="password"
              id="confirm"
              name="password"
              v-model="$v.form.confirm.$model"
              :state="validateState('confirm')"
              aria-describedby="confirm-feedback"
              placeholder=""
            ></b-form-input>

            <b-form-invalid-feedback id="confirm-feedback"
              >Passwords must match.</b-form-invalid-feedback
            >
          </b-form-group>
          <!--begin::Action-->
          <div class="kt-login__actions">
            <b-button
              id="kt_submit"
              type="submit"
              class="btn btn-auth login-btn-auth btn-primary btn-elevate kt-login__btn-primary kt-spinner--light kt-spinner--right"
              >Reset Password</b-button
            >
          </div>
          <!--end::Action-->
        </b-form>
        <!--end::Options-->
      </div>
      <!--end::Signin-->
    </div>
    <!--end::Body-->
    <AlertModal
      v-bind="alertModal"
      v-model="alertModal.show"
      @dismiss="resetAlert"
    />
  </div>
</template>

<script>
import "./auth.css";
import AlertModal from "@/components/widgets/AlertModal.vue";
import { mapState } from "vuex";
import { CONFIRM_USER } from "@/store/auth.module";
import { LOGOUT } from "@/store/auth.module";
import { Auth } from "aws-amplify";
import { validationMixin } from "vuelidate";
import { email, required, minLength, sameAs } from "vuelidate/lib/validators";
import PasswordValidationMixin from "@/components/widgets/PasswordValidationMixin.js";

const passwordValidationMixin = PasswordValidationMixin(
  "password",
  true,
  "form"
);

export default {
  mixins: [validationMixin, passwordValidationMixin],
  components: {
    AlertModal
  },
  data() {
    return {
      form: {
        email: null,
        password: null,
        confirm: null,
        code: null
      },
      alertModal: {
        show: false,
        text: "",
        type: AlertModal.INFORMATION
      }
    };
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: passwordValidationMixin.passwordValidation,
      code: {
        required,
        minLength: minLength(6)
      },
      confirm: {
        required,
        sameAsPassword: sameAs("password")
      }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name] ?? this.$v.confirm[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        email: null,
        password: null,
        code: null,
        comfirm: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const email = this.$v.form.email.$model;
      const password = this.$v.form.password.$model;
      const code = this.$v.form.code.$model;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = document.getElementById("kt_submit");
      submitButton.classList.add("kt-spinner");
      Auth.forgotPasswordSubmit(email, code, password)
        .then(data => {
          this.alert("Password Reset", AlertModal.SUCCESS);
          submitButton.classList.remove("kt-spinner");
          this.$router.push({ name: "login" });
        })
        .catch(err => {
          this.alert(err.message ?? err, AlertModal.ERROR);
          submitButton.classList.remove("kt-spinner");
        });
    },
    alert(text, type) {
      if (text) this.alertModal.text = text;
      if (type) this.alertModal.type = type;
      if (this.alertModal.text) this.alertModal.show = true;
    },
    resetAlert() {
      this.alertModal.text = "";
      this.alertModal.type = AlertModal.INFORMATION;
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    backgroundImage() {
      return process.env.BASE_URL + "assets/media/bg/bg-4.jpg";
    }
  }
};
</script>
